import { render, staticRenderFns } from "./XlsxQuizUploader.vue?vue&type=template&id=97726602&scoped=true&"
import script from "./XlsxQuizUploader.vue?vue&type=script&lang=js&"
export * from "./XlsxQuizUploader.vue?vue&type=script&lang=js&"
import style0 from "./XlsxQuizUploader.vue?vue&type=style&index=0&id=97726602&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97726602",
  null
  
)

export default component.exports